import { Pipe, PipeTransform } from '@angular/core';

/* temporary pipe / moving to NgCore library */
@Pipe({
  name: 'stripTags'
})
export class StripTagsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    return value.replace(/<\S[^><]*>/g, '');
  }
}
